import React from "react";
import "./Projects.css";

export const Projects = () => {
  return (
    <>
      <div className="section" >
        <h2 className="section__title different" data-aos="fade-right"  >Projects</h2>
        <div className="allProjects">
          <div className="projects_container" data-aos="fade-right" data-aos-offset="200">
       
 
            <div className="project">
            
              <div className="project_information">
                <h2>AgroMed</h2>
                <p>
                An agricultural app that can aid farmers in managing crops, increasing productivity, and profitability in farming.
                </p>
                <div>
                <div class="chip-container">
                  <div class="chip">Flutter</div>
                  <div class="chip">Firebase</div>
                  <div class="chip">Tensorflow</div>
                  <div class="chip">Cloudstore</div>
                </div>

                
                 
                </div>
                
                <div>
                
                  <a
                    href="https://github.com/cloneartist/AgroMed"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
             
              <div className="project_information">
                <h2>Upcampus</h2>
                <p>
                This project aims to teach coding to youngsters through a series of weekly sessions using a web and app platform. 
                </p>
                <div>


                <div class="chip-container">
                  <div class="chip">Flutter</div>
                  <div class="chip">Netlify</div>
                  <div class="chip">HTML</div>
                  <div class="chip">CSS</div>
                </div>
                 
                </div>
                <div>
                
                  <a
                    href="https://github.com/cloneartist/Upcampus"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              {/* <div className="project_videocontainer">
                <div>
                  <img src="https://i.ibb.co/M2qW7xL/apijs-npm.png" alt="" />
                </div>
              </div> */}
              <div className="project_information">
                <h2>Daillo Diary</h2>
                <p>
                Daillo is a diary app and website, designed to record your activities, daily events, experiences, thoughts, ideas throughout the day, and sync data across all your devices & PC.
                </p>
                <div>
                <div class="chip-container">
                  <div class="chip">Flutter</div>
                  <div class="chip">Cloudstore</div>
                  <div class="chip">Firebase</div>
                </div>
         
                </div>
                <div>
                  <a
                    href="https://www.npmjs.com/package/apijs-mongo"
                    target="_blank"
                    rel="noreferrer"
                  >
  
                  </a>
                  <a
                    href="https://github.com/cloneartist/Daily-Diary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
 
              <div className="project_information">
                <h2>Paatukari.ml</h2>
                <p>
                A custom song lyric generator that produces unique lyrics tailored to the user's input. Currently supports malayalam songs.
                </p>
                <div>

                <div class="chip-container">
                  <div class="chip">HTML</div>
                  <div class="chip">CSS</div>
                  <div class="chip">Flask</div>
                  <div class="chip">Python</div>
                  <div class="chip">Heroku</div>

                </div>
        
                </div>
                <div>
                  <a
                    href="https://drive-system.herokuapp.com/user/"
                    target="_blank"
                    rel="noreferrer"
                  >
        
                  </a>
                  <a
                    href="https://github.com/cloneartist/SitharaBot"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        
        </div>
      </div>
      
    </>
  );

};
